import type { ParagraphBlogPosts as ParagraphBlogPostsData } from "@/lib/api/cms-catalog";
import { ParagraphHeading } from "../shared/ParagraphHeading";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "../Paragraph.module.css";

/**
 * Layout 25 - `PARAGRAPH_BLOG_POSTS_LAYOUT`: karty wpisów c_blog.
 *
 * Backend (`IPARAGRAPH_CONTROLLER::processBlogPostsLayout`) ogranicza listę
 * do 3 postów (config_form.blog_posts -> `array_slice(0, 3)`). Każdy post ma
 * obraz, kategorię, datę publikacji, licznik wyświetleń i link do artykułu.
 */
export function ParagraphBlogPosts({
  paragraph,
  t,
}: {
  paragraph: ParagraphBlogPostsData;
  t: ParagraphTranslations;
}) {
  const posts = paragraph.posts ?? [];

  return (
    <section className={styles.paragraph}>
      <ParagraphHeading name={paragraph.name} centerHeader={paragraph.center_header} />
      {posts.length === 0 ? (
        <div className={styles.empty}>{t.blogPosts.empty}</div>
      ) : (
        <div className={styles.blogPosts}>
          {posts.map((post) => (
            <a
              key={post.id}
              className={styles.blogPost}
              href={post.href.art}
              aria-label={t.blogPosts.open(post.name)}
            >
              {post.image?.href && (
                <img
                  className={styles.blogPostImg}
                  src={post.image.href}
                  alt={post.image.alt ?? post.name}
                  loading="lazy"
                  width={post.image.width ?? undefined}
                  height={post.image.height ?? undefined}
                />
              )}
              <div className={styles.blogPostBody}>
                {post.category && (
                  <span className={styles.blogPostCategory}>{post.category}</span>
                )}
                <h3 className={styles.blogPostName}>{post.name}</h3>
                {post.publication_date && (
                  <span className={styles.blogPostMeta}>
                    {formatDate(post.publication_date)}
                  </span>
                )}
              </div>
            </a>
          ))}
        </div>
      )}
    </section>
  );
}

/**
 * Format daty z YYYY-MM-DD lub YYYY-MM-DD HH:MM:SS -> locale string.
 * Fallback: zwraca raw string gdy parsing fail (np. nietypowy format z bazy).
 */
function formatDate(raw: string): string {
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return raw;
  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}
